import React from "react";
import DefaultLayout from "../components/layout/Default";

import AboutUs from "./landing-sections/AboutUs";
import BookNow from "./landing-sections/BookNow";
import Header from "./landing-sections/Header";
import OurStyle from "./landing-sections/OurStyle";
import Services from "./landing-sections/Services";

import { useMediaQuery, useTheme } from "@mui/material";
import Footer from "./landing-sections/Footer";
import Announcement from "@/components/misc/Announcement";

const Landing: React.FC = () => {
  return (
    <DefaultLayout>
      <SectionLayout id="section-header">
        <Header />
      </SectionLayout>
      <Announcement startDate="2026-07-06" endDate="2026-07-31" />
      <SectionLayout id="section-services" fullHeight>
        <Services />
      </SectionLayout>
      <SectionLayout id="section-our-style" fullHeight contentMiddle>
        <OurStyle />
      </SectionLayout>
      <SectionLayout id="section-about-us" fullHeight>
        <AboutUs />
      </SectionLayout>

      <SectionLayout id="section-book-now" fullHeight>
        <BookNow />
      </SectionLayout>
      <Footer />
    </DefaultLayout>
  );
};

export default Landing;

const SectionLayout = ({
  children,
  id,
  fullHeight = false,
  contentMiddle = false,
}: {
  children: React.ReactNode;
  id: string;
  fullHeight?: boolean;
  contentMiddle?: boolean;
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div
      id={id}
      style={{
        marginTop: "60px",
        marginBottom: "100px",
        minHeight: fullHeight ? "100vh" : "auto",
        display: contentMiddle ? "flex" : "block",
        flexDirection: "column",
        justifyContent: contentMiddle ? "center" : undefined,
        alignItems: contentMiddle ? "center" : undefined,
      }}
    >
      {children}
    </div>
  );
};
